<template>
  <div class="businessList">
    <div class="noData" v-if="nodata || searchResult || tenderLoad">
      <div class="noDataCon" v-if="nodata">
        <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/noData.png" alt="">
        <p>暂无数据</p>
      </div>
      <div class="noDataSearch" v-else-if="searchResult">
        <h4>“{{keySearch}}”相关的搜索结果</h4>
        <p>共0个搜索结果，您可以尝试其他搜索词</p>
      </div>
      <div class="loadingBox" v-loading="tenderLoad"></div>
    </div>
    <ul class="clearfix" v-show="!tenderLoad">
      <li class="col-xs-12 col-sm-6 col-md-4 col-lg-4" v-for="(item,index) in businessList.ebsInvitatioExtList" :key="index">
        <div class="businessBg" v-if="index==0 && item.bulletinName ==''">
          <a href="https://ep.fosunproperty.com:8888/index/group_zblist.aspx" target="_blank" style="display:block;">
            <div class="businessToplogo">
            </div>
          </a>
          <div class="businessBox8"><p></p></div>
          <div class="businessBox16"><p></p></div>
        </div>
        <div class="businessBg" v-else-if="item.soureType != 'INV0003' && reminderShow && item.bulletinName !==''">
          <div class="businessTop" @click="clickViewFn(viewBussinessUrl,item.bulletinId,item.soureType,item.signupUrl, true, item, index)">
            <h4 style="-webkit-box-orient: vertical;" v-html="antiCreeping(item.bulletinName)">{{item.bulletinName}}</h4>
            <p v-html="antiCreeping(item.signEndTime,'截止日期：')"></p>
          </div>
          <div class="businessBottom" @click="clickViewFn(viewBussinessUrl,item.bulletinId,item.soureType,item.signupUrl, true, item, index)">
            <p><span>发布日期：</span><b style="font-weight: normal" v-html="antiCreeping(item.publishTime,' ')"></b></p>
            <p><span>招标主体：</span><b style="font-weight: normal"  v-html="antiCreeping(item.agentOrgName)"></b></p>
          </div>
          <div class="businessBox8"><p></p></div>
          <div class="businessBox16"><p></p></div>
        </div>
        <el-popover
          v-else
          popper-class="reminderHover hidden-xs"
          placement="bottom"
          width="400"
          trigger="hover">
          <div class="reminderCon">
            温馨提示：此项目为明源系统发布的公告，如须报名或查看项目进度，请点击公告至明源系统注册/登录进行操作。
<!--            <p>详询 <span class="reminderRed">400-602-7009</span></p>-->
          </div>
          <div class="businessBg" slot="reference" v-if="item.bulletinName !==''">
            <div class="businessTop" @click="clickViewFn(viewBussinessUrl,item.bulletinId,item.soureType,item.signupUrl)">
              <h4 style="-webkit-box-orient: vertical;" v-html="antiCreeping(item.bulletinName)">{{item.bulletinName}}</h4>
              <p v-html="antiCreeping(item.signEndTime,'截止日期：')"></p>
            </div>
            <div class="businessBottom" @click="clickViewFn(viewBussinessUrl,item.bulletinId,item.soureType,item.signupUrl)">
              <p><span>发布日期：</span><b style="font-weight: normal" v-html="antiCreeping(item.publishTime,' ')"></b></p>
              <p><span>招标主体：</span><b style="font-weight: normal"  v-html="antiCreeping(item.agentOrgName)"></b></p>
            </div>
            <div class="businessBox8"><p></p></div>
            <div class="businessBox16"><p></p></div>
          </div>
        </el-popover>
      </li>
    </ul>
    <!-- <v-bootPage class="hidden-xs hidden-sm" v-ref:page :async="false" :data="businessList" :lens="lenArr" :page-len="pageLen" :param="param"></v-bootPage> -->
    <el-dialog
      v-if="!timeConShow"
      custom-class="realEstate"
      title="提示"
      :visible.sync="centerDialogVisible">
      <p>您即将进入地产系统，为确保功能正常使用，请使用IE10及以上版本浏览器，并设置兼容性</p>
      <p><a href="https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx">IE10兼容性设置方法.docx</a></p>
      <span slot="footer" class="dialog-footer clearfix">
        <el-checkbox v-model="noMorePrompts">今天不再提示</el-checkbox>
        <el-button type="primary" @click="centerDialogFn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-else
      custom-class="realEstate"
      title="地产系统暂停服务通知"
      :visible.sync="centerDialogVisible"
      center>
      <p style="text-align: left;padding-left: 30px;margin: 0px;">由于地产系统改造升级，8月3日8点到17点将暂停服务，请知悉！造成不便，敬请谅解！</p>
      <span slot="footer" class="dialog-footer clearfix">
        <el-checkbox v-model="noMorePrompts">今天不再提示</el-checkbox>
        <el-button type="primary" @click="centerDialogFn">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import { mapState } from 'vuex'
import Cookies from 'js-cookie'
import {customSearchResultClick} from '@/assets/js/sensors'

export default {
  props: ['businessList','viewBussinessUrl','customerPageUrl','tenderLoad','keySearch','searchResult','nodata','currentSourceType','reminderShow','sensorsInfo'],
  data () {
    return {
      userInfo:{},
      companyInfo:{},
      refSysId:'',
      mingyuanFlag:'',
      centerDialogVisible:false,
      noMorePrompts:false,
      messageUrl:'',
      bulletinId:'',
      sourceType:'',
      signupUrl:'',
      timeConShow:false
    }
  },
  computed: mapState([
    'KP'
  ]),
  created () {
    if(this.getToken('isLogin') == 100){
      this.userInfo = JSON.parse(this.getDAesString(this.getToken('userInfo'),this.KP.key,this.KP.iv));
      this.companyInfo = JSON.parse(this.getDAesString(this.getToken('companyInfo'),this.KP.key,this.KP.iv));
      this.refSysId = this.getDAesString(this.getToken('refSysId'),this.KP.key,this.KP.iv);
      this.mingyuanFlag = this.getToken('mingyuanFlag');
    }
//    console.log(this.antiCreeping("hh"))
  },
  methods:{
    clickViewFn(url,bulletinId,sourceType,signupUrl,clickType, item, index){

      let timeShow = false;
      this.messageUrl = url;
      this.bulletinId = bulletinId;
      this.sourceType = sourceType;
      this.signupUrl = signupUrl;
      if(this.getNowFormatDate() == "2019-08-03"){
        this.timeConShow = true;
        timeShow = true;
        console.log(this.getNowFormatDate());
      }else{
        console.log(this.getNowFormatDate());
        this.timeConShow = false;
        timeShow = true;
      }
      if(timeShow){
        if(sourceType == "INV0002" && this.getCookie('TODAY_NO_MORE_REMINDER') == 0){
          this.centerDialogVisible = true;
        }else{
          this.viewBussiness(this.messageUrl,this.bulletinId,this.sourceType,this.signupUrl)
        }
      }

      // 埋点
      try {
        if (clickType) {
          let position_number = (Number(this.sensorsInfo.currentPageTender)-1) * 10 + (index + 1)
          console.log(position_number)
          customSearchResultClick({
            position: "招标公告",
            new_keyword: this.keySearch || '',
            keyword_type:this.sensorsInfo.sensorsCurrentSourceName,
            position_number: position_number,
            project_name: item.bulletinName,
            supplier: item.agentOrgName
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
     async viewBussiness(url,bulletinId,sourceType,signupUrl){
       try {
         await this.$store.dispatch('findWebDtoHandler');
       } catch (e) {}

       if(this.getToken('checkFlag') == 200 && this.getCookie('TALK_LATER_'+this.getCookie('justId'))>=14){
         if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
           this.$alert('<p>请登录pc端完善企业信息</p>', '', {
             dangerouslyUseHTMLString: true,
             customClass:'mobileText',
             center: true,
             showClose:false
           });
         } else {
           await this.$store.dispatch('findWebDtoHandler');
           this.$store.dispatch('informationCompletion');
         }


       }else{
         let tenderUrl = url + bulletinId;
         if(sourceType == 'INV0002'){
           if(this.getToken('isLogin') == ''){
             // this.$router.push({path:'/login'});
             window.location.href= signupUrl+"&flag=000";
           }else if(this.getToken('examineStatus') == '200'){
             this.$router.push({path:"registerExamine",query:{email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,trueName:this.userInfo.trueName}});
           }else if(this.getToken('examineStatus') == '300'){
             this.$router.push({path:"registerFailed",query:{userId:this.userInfo.id,email:this.userInfo.email,companyId:this.userInfo.companyId,companyName:this.userInfo.companyName,orgIdentity:this.userInfo.orgIdentity,regAddrType:this.userInfo.regAddrType,regeisterType:this.getToken('regeisterType'),exmaineMessage:this.getToken('exmaineMessage'),createUserId:this.userInfo.createUserId}});
           }else{

             if(this.mingyuanFlag == '0'){
               let foSunUrl = "https://ep.fosunproperty.com:8888/";
               let userSsoToken = Cookies.get("user_sso_token");
               signupUrl = signupUrl.split("?")[1];
               let guid = this.getUrlKey('guid',"?"+signupUrl)
               let landedUrl = foSunUrl  +"Interface/YiLianAction.aspx?action=bidInfoPage&token="+userSsoToken+"&pguid="+ this.refSysId+"&bidGuid="+guid;
               window.location.href= landedUrl;
             }else if(this.mingyuanFlag == '1'){
               window.location.href= signupUrl+"&flag=111";
             }else{
               window.location.href= signupUrl+"&flag=111";
             }
           }
         }else if(sourceType == 'INV0003'){
           window.location.href=signupUrl;
         } else if (sourceType == 'INV0001') {
           window.open(signupUrl.indexOf("http://") > -1 ? signupUrl : 'http://' + signupUrl);
         } else{
           window.location.href= tenderUrl;
         }
       }
    },
    ieDown(){
      let url = "https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx"
      this.$axios.get('/onelink.mdata.main.api/upload/getDownloadURL?fioleKey='+url, {
      }).then((res) => {
        window.location.href=res.data;
      }).catch((err) => {
        console.log(err)
      })
    },
    centerDialogFn(){
      this.centerDialogVisible = false;
      if(this.noMorePrompts){
        this.$axios.post('/onelink.mdata.main.api/web/todayNoMoreRemainder', {
        }).then((res) => {
          if(res.data.code == 0){
            this.viewBussiness(this.messageUrl,this.bulletinId,this.sourceType,this.signupUrl)
          }
        }).catch((err) => {
          console.log(err)
        })
      }else{
        this.viewBussiness(this.messageUrl,this.bulletinId,this.sourceType,this.signupUrl)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenderNoticeList/index.vue